var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('buscar-movimento-compra',{attrs:{"erros":_vm.erros,"movimento":_vm.movimento},on:{"pesquisarMovimentoCompra":function($event){return _vm.pesquisarMovimentoCompra($event)},"inserir":function($event){return _vm.inserirDespesaCompra($event)}}},[_c('template',{slot:"botoes"},[_c('app-btn-voltar')],1)],2),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }